/**
 * Option lists the create form offers: locations, industries, cities and the
 * people who can own a record (CT-5525).
 *
 * The lists are DATA, not constants in a component: a tenant decides them. Owner
 * search is server-side (`SearchableSelect` debounces and calls back), so a large
 * directory never has to be loaded whole.
 *
 * Real signatures and snake_case bodies; only the transport is stubbed.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

const mapOption = (raw = {}) => ({
  value: raw.value ?? raw.id ?? '',
  label: raw.label ?? raw.name ?? '',
});

/** `{ locations, industries, cities }`, each an array of `{ value, label }`. */
export const mapApiFormOptionsToUi = (raw = {}) => ({
  locations: (raw.locations ?? []).map(mapOption),
  industries: (raw.industries ?? []).map(mapOption),
  cities: (raw.cities ?? []).map(mapOption),
});

/** `{ id, name, subtitle }`, the shape `SearchableSelect` consumes. */
export const mapApiOwnerToUi = (raw = {}) => ({
  id: raw.user_uuid ?? raw.userUuid ?? raw.id ?? '',
  name: raw.name ?? raw.display_name ?? raw.displayName ?? '',
  subtitle: raw.email ?? raw.role ?? null,
});

/** TODO(CT-5525 / backend): `POST /v0/profile/records/options` is assumed. */
export const listRecordFormOptions = async () => {
  const response = await request('/v0/profile/records/options', {});
  return validateApiResponse(response, 'Failed to load the form options');
};

/** TODO(CT-5525 / backend): `POST /v0/profile/owners/list` is assumed. */
export const listOwners = async ({ page = 1, pageSize = 20, search } = {}) => {
  const response = await request('/v0/profile/owners/list', {
    page,
    page_size: pageSize,
    ...(search ? { search } : {}),
  });
  return validateApiResponse(response, 'Failed to load people');
};
